

// Préchargement des images de bannière

export default function bannerInit() {
    let section = document.querySelector('.section-titre');
    let sectionBg = document.querySelector('.section-titre-bg');
    const isScreenSmall = document.body.clientWidth < 1024;

    if (sectionBg) {
        const totalImages = 13;
        const folder = isScreenSmall ? 'banner--mobile' : 'banner--desktop';
        const prefix = isScreenSmall ? 'banner--mobile-' : 'banner--desktop-';

        // Cacher l'élément pendant le chargement
        sectionBg.style.opacity = '0';

        // Fonction pour charger toutes les images et attendre qu'elles soient toutes en cache
        const preloadImages = async () => {
            const images = [];
            const promises = [];

            for (let i = 1; i <= totalImages; i++) {
                const imagePromise = new Promise((resolve, reject) => {
                    const img = new Image();
                    const imagePath = `/wp-content/themes/annee-rap-2025/public/assets/img/${folder}/${prefix}${i}.png`;

                    img.onload = () => {
                        // Forcer le décodage de l'image
                        if (img.decode) {
                            img.decode()
                                .then(() => {
                                    resolve(img);
                                })
                                .catch(() => {
                                    resolve(img);
                                });
                        } else {
                            resolve(img);
                        }
                    };

                    img.onerror = () => {
                        reject(new Error(`Failed to load ${imagePath}`));
                    };

                    img.src = imagePath;
                    images.push(img);
                });

                promises.push(imagePromise);
            }

            try {
                // Attendre que TOUTES les images soient chargées ET décodées
                await Promise.allSettled(promises);

                // Délai supplémentaire pour garantir que le cache du navigateur est stable
                await new Promise(resolve => setTimeout(resolve, 300));

                // Démarrer l'animation
                sectionBg.classList.add('loaded');
                sectionBg.style.opacity = '1';

            } catch (error) {
                // En cas d'erreur, on affiche quand même pour ne pas bloquer le site
                sectionBg.classList.add('loaded');
                sectionBg.style.opacity = '1';
            }
        };

        // Lancer le préchargement
        preloadImages();
    }
}